import styled, { CSSProp } from 'styled-components'

export const FlagEmojiUi = styled.img<{
  styles?: CSSProp
}>`
  box-sizing: border-box;

  ${({ styles }) => styles}
`
